import {
  Content,
  Item,
  Portal,
  Root,
  Trigger,
} from '@radix-ui/react-dropdown-menu';
import cl from 'clsx';

import { PlaceHolderImage } from '@/shared/assets';
import { useLogout } from '@/shared/hooks';

import classes from './ActiveUserBox.module.scss';
import { useActiveUser } from '@/true-fsd/data/advertiser-account';

export type ActiveUserBoxProps = {
  className?: string;
};
export const ActiveUserBox = ({ className }: ActiveUserBoxProps) => {
  const logout = useLogout();
  const user = useActiveUser();

  return (
    <Root>
      <Trigger className={cl(classes.trigger, className)}>
        <img
          src={user.photo_url ?? PlaceHolderImage}
          className={classes.icon}
        />
        <div className={classes.name}>{user.full_name}</div>
      </Trigger>
      <Portal>
        <Content className={classes.content}>
          <Item className={classes.item} onClick={logout}>
            Выйти
          </Item>
        </Content>
      </Portal>
    </Root>
  );
};
